import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_COMMERCE_FREE, ONBOARDING_STARTER_COMMERCE } from 'getting-started-shared-tasks/onboardingKeys';
import { CTAS } from '../constants/enums';
import { COMMERCE_CONNECT_STRIPE_URL, COMMERCE_OVERVIEW_TOOLS_URL, COMMERCE_PAYMENTS_LESSON_URL_PROD, COMMERCE_PAYMENTS_LESSON_URL_QA } from '../constants/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const getDefaultCommerceLearnMoreConfig = __appContexts => ({
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "commerce.learnMore.description"
  }),
  ctas: [{
    ctaId: CTAS.COMMERCE_OVERVIEW_TOOLS,
    href: COMMERCE_OVERVIEW_TOOLS_URL,
    external: true,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce.learnMore.ctas.overviewTools"
    }),
    icon: 'presentation'
  }, {
    ctaId: CTAS.COMMERCE_PAYMENTS_LESSON,
    href: enviro.isQa() ? COMMERCE_PAYMENTS_LESSON_URL_QA : COMMERCE_PAYMENTS_LESSON_URL_PROD,
    external: true,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce.learnMore.ctas.paymentsLesson"
    }),
    icon: 'cap'
  }, {
    ctaId: CTAS.COMMERCE_CONNECT_STRIPE,
    href: COMMERCE_CONNECT_STRIPE_URL,
    external: true,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce.learnMore.ctas.connectStripe"
    }),
    icon: 'marketplace'
  }]
});
export default function getCommerceViewConfig(__appContexts) {
  return {
    [ONBOARDING_COMMERCE_FREE]: {
      learnMore: getDefaultCommerceLearnMoreConfig(__appContexts)
    },
    [ONBOARDING_STARTER_COMMERCE]: {
      learnMore: getDefaultCommerceLearnMoreConfig(__appContexts)
    }
  };
}